/**
 * School Calendar Events Data
 * P.S. 155 William Paca School
 * 2025-2026 Academic Year
 */

const events = [
  // September 2025
  {
    id: 1,
    title: 'First Day of School',
    titleES: 'Primer Día de Clases',
    date: new Date(2025, 8, 4),
    category: 'academic',
    allDay: true,
    description: 'Welcome back! First day of the 2025-2026 school year',
    descriptionES: '¡Bienvenidos! Primer día del año escolar 2025-2026'
  },
  {
    id: 2,
    title: 'Welcome Back Night 2:30-4pm / Curriculum Night 5-7pm',
    titleES: 'Noche de Bienvenida 2:30-4pm / Noche de Currículo 5-7pm',
    date: new Date(2025, 8, 17),
    category: 'event',
    allDay: false,
    description: 'Welcome Back Night and Curriculum Night for families',
    descriptionES: 'Noche de bienvenida y noche de currículo para las familias'
  },
  {
    id: 3,
    title: 'Coffee and Community with Ms. Sanabria',
    titleES: 'Café y Comunidad con la Sra. Sanabria',
    date: new Date(2025, 8, 19),
    category: 'event',
    allDay: false,
    description: 'Coffee and Community session with Principal Sanabria',
    descriptionES: 'Sesión de café y comunidad con la directora Sanabria'
  },
  {
    id: 4,
    title: 'Rosh Hashanah - School Not in Session',
    titleES: 'Rosh Hashanah - Escuela No Está en Sesión',
    date: new Date(2025, 8, 23),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Rosh Hashanah (September 23-24)',
    descriptionES: 'Escuela cerrada por Rosh Hashanah (23-24 de septiembre)'
  },
  {
    id: 5,
    title: 'Rosh Hashanah - School Not in Session',
    titleES: 'Rosh Hashanah - Escuela No Está en Sesión',
    date: new Date(2025, 8, 24),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Rosh Hashanah (September 23-24)',
    descriptionES: 'Escuela cerrada por Rosh Hashanah (23-24 de septiembre)'
  },
  {
    id: 6,
    title: 'SLT Meeting 2:30-4:00 PM',
    titleES: 'Reunión SLT 2:30-4:00 PM',
    date: new Date(2025, 8, 25),
    category: 'meeting',
    allDay: false,
    description: 'School Leadership Team meeting',
    descriptionES: 'Reunión del equipo de liderazgo escolar'
  },

  // October 2025
  {
    id: 7,
    title: 'Yom Kippur - School Not in Session',
    titleES: 'Yom Kippur - Escuela No Está en Sesión',
    date: new Date(2025, 9, 2),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Yom Kippur',
    descriptionES: 'Escuela cerrada por Yom Kippur'
  },
  {
    id: 8,
    title: 'Panther Pride Assembly',
    titleES: 'Asamblea Orgullo Pantera',
    date: new Date(2025, 9, 6),
    category: 'event',
    allDay: false,
    description: 'Monthly Panther Pride Assembly',
    descriptionES: 'Asamblea mensual de Orgullo Pantera'
  },
  {
    id: 9,
    title: 'Italian Heritage/Indigenous Peoples\' Day - School Not in Session',
    titleES: 'Día del Patrimonio Italiano/Día de los Pueblos Indígenas - No Hay Clases',
    date: new Date(2025, 9, 13),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Italian Heritage/Indigenous Peoples\' Day',
    descriptionES: 'Escuela cerrada por el Día del Patrimonio Italiano/Día de los Pueblos Indígenas'
  },
  {
    id: 10,
    title: 'Coffee and Community with Ms. Sanabria',
    titleES: 'Café y Comunidad con la Sra. Sanabria',
    date: new Date(2025, 9, 17),
    category: 'event',
    allDay: false,
    description: 'Coffee and Community session with Principal Sanabria',
    descriptionES: 'Sesión de café y comunidad con la directora Sanabria'
  },
  {
    id: 11,
    title: 'Diwali - School Not in Session',
    titleES: 'Diwali - Escuela No Está en Sesión',
    date: new Date(2025, 9, 20),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Diwali',
    descriptionES: 'Escuela cerrada por Diwali'
  },
  {
    id: 12,
    title: 'SLT Meeting 2:30-4:00 PM',
    titleES: 'Reunión SLT 2:30-4:00 PM',
    date: new Date(2025, 9, 24),
    category: 'meeting',
    allDay: false,
    description: 'School Leadership Team meeting',
    descriptionES: 'Reunión del equipo de liderazgo escolar'
  },
  {
    id: 13,
    title: 'Reading Buddies / Character Parade',
    titleES: 'Compañeros de Lectura / Desfile de Personajes',
    date: new Date(2025, 9, 31),
    category: 'event',
    allDay: false,
    description: 'Reading Buddies and Character Parade event',
    descriptionES: 'Evento de compañeros de lectura y desfile de personajes'
  },

  // November 2025
  {
    id: 14,
    title: 'Panther Pride Assembly',
    titleES: 'Asamblea Orgullo Pantera',
    date: new Date(2025, 10, 3),
    category: 'event',
    allDay: false,
    description: 'Monthly Panther Pride Assembly',
    descriptionES: 'Asamblea mensual de Orgullo Pantera'
  },
  {
    id: 15,
    title: 'Election Day - Students Not in Attendance',
    titleES: 'Día de Elecciones - Estudiantes No Asisten',
    date: new Date(2025, 10, 4),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Election Day',
    descriptionES: 'Escuela cerrada por el Día de Elecciones'
  },
  {
    id: 16,
    title: 'Parent Teacher Conference - ½ Day',
    titleES: 'Conferencia de Padres y Maestros - Medio Día',
    date: new Date(2025, 10, 6),
    category: 'event',
    allDay: false,
    description: 'Parent Teacher Conference - Half Day',
    descriptionES: 'Conferencia de padres y maestros - Medio día'
  },
  {
    id: 17,
    title: 'Picture Day',
    titleES: 'Día de Fotos',
    date: new Date(2025, 10, 7),
    category: 'event',
    allDay: false,
    description: 'School Picture Day',
    descriptionES: 'Día de fotos escolares'
  },
  {
    id: 18,
    title: 'Classroom Showcase Grades 3K-2nd',
    titleES: 'Exhibición de Aula Grados 3K-2do',
    date: new Date(2025, 10, 14),
    category: 'event',
    allDay: false,
    description: 'Classroom Showcase for grades 3K through 2nd',
    descriptionES: 'Exhibición de aula para grados 3K a 2do'
  },
  {
    id: 19,
    title: 'Veterans Day - School Not in Session',
    titleES: 'Día de los Veteranos - Escuela No Está en Sesión',
    date: new Date(2025, 10, 17),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Veterans Day',
    descriptionES: 'Escuela cerrada por el Día de los Veteranos'
  },
  {
    id: 20,
    title: 'Classroom Showcase Grades 3rd-5th',
    titleES: 'Exhibición de Aula Grados 3ro-5to',
    date: new Date(2025, 10, 18),
    category: 'event',
    allDay: false,
    description: 'Classroom Showcase for grades 3rd through 5th',
    descriptionES: 'Exhibición de aula para grados 3ro a 5to'
  },
  {
    id: 21,
    title: 'SLT Meeting 2:30-4:00 PM',
    titleES: 'Reunión SLT 2:30-4:00 PM',
    date: new Date(2025, 10, 19),
    category: 'meeting',
    allDay: false,
    description: 'School Leadership Team meeting',
    descriptionES: 'Reunión del equipo de liderazgo escolar'
  },
  {
    id: 22,
    title: 'Coffee and Community with Ms. Sanabria',
    titleES: 'Café y Comunidad con la Sra. Sanabria',
    date: new Date(2025, 10, 21),
    category: 'event',
    allDay: false,
    description: 'Coffee and Community session with Principal Sanabria',
    descriptionES: 'Sesión de café y comunidad con la directora Sanabria'
  },
  {
    id: 23,
    title: 'Thanksgiving Celebration',
    titleES: 'Celebración de Acción de Gracias',
    date: new Date(2025, 10, 24),
    category: 'event',
    allDay: false,
    description: 'Thanksgiving Celebration at school',
    descriptionES: 'Celebración de Acción de Gracias en la escuela'
  },
  {
    id: 24,
    title: 'Thanksgiving Recess',
    titleES: 'Receso de Acción de Gracias',
    date: new Date(2025, 10, 27),
    category: 'holiday',
    allDay: true,
    description: 'Thanksgiving Recess begins (November 27-28)',
    descriptionES: 'Comienza el receso de Acción de Gracias (27-28 de noviembre)'
  },
  {
    id: 25,
    title: 'Thanksgiving Recess',
    titleES: 'Receso de Acción de Gracias',
    date: new Date(2025, 10, 28),
    category: 'holiday',
    allDay: true,
    description: 'Thanksgiving Recess continues',
    descriptionES: 'Continúa el receso de Acción de Gracias'
  },

  // December 2025
  {
    id: 26,
    title: 'Panther Pride Assembly',
    titleES: 'Asamblea Orgullo Pantera',
    date: new Date(2025, 11, 1),
    category: 'event',
    allDay: false,
    description: 'Monthly Panther Pride Assembly',
    descriptionES: 'Asamblea mensual de Orgullo Pantera'
  },
  {
    id: 27,
    title: 'SLT Meeting 2:30-4:00 PM',
    titleES: 'Reunión SLT 2:30-4:00 PM',
    date: new Date(2025, 11, 12),
    category: 'meeting',
    allDay: false,
    description: 'School Leadership Team meeting',
    descriptionES: 'Reunión del equipo de liderazgo escolar'
  },
  {
    id: 28,
    title: 'Coffee and Community with Ms. Sanabria',
    titleES: 'Café y Comunidad con la Sra. Sanabria',
    date: new Date(2025, 11, 19),
    category: 'event',
    allDay: false,
    description: 'Coffee and Community session with Principal Sanabria',
    descriptionES: 'Sesión de café y comunidad con la directora Sanabria'
  },
  {
    id: 29,
    title: 'Winter Recess',
    titleES: 'Receso de Invierno',
    date: new Date(2025, 11, 24),
    category: 'holiday',
    allDay: true,
    description: 'Winter Recess begins (December 24 - January 2)',
    descriptionES: 'Comienza el receso de invierno (24 de diciembre - 2 de enero)'
  },
  {
    id: 30,
    title: 'Winter Recess',
    titleES: 'Receso de Invierno',
    date: new Date(2025, 11, 25),
    category: 'holiday',
    allDay: true,
    description: 'Winter Recess continues',
    descriptionES: 'Continúa el receso de invierno'
  },
  {
    id: 31,
    title: 'Winter Recess',
    titleES: 'Receso de Invierno',
    date: new Date(2025, 11, 26),
    category: 'holiday',
    allDay: true,
    description: 'Winter Recess continues',
    descriptionES: 'Continúa el receso de invierno'
  },
  {
    id: 32,
    title: 'Winter Recess',
    titleES: 'Receso de Invierno',
    date: new Date(2025, 11, 27),
    category: 'holiday',
    allDay: true,
    description: 'Winter Recess continues',
    descriptionES: 'Continúa el receso de invierno'
  },
  {
    id: 33,
    title: 'Winter Recess',
    titleES: 'Receso de Invierno',
    date: new Date(2025, 11, 28),
    category: 'holiday',
    allDay: true,
    description: 'Winter Recess continues',
    descriptionES: 'Continúa el receso de invierno'
  },
  {
    id: 34,
    title: 'Winter Recess',
    titleES: 'Receso de Invierno',
    date: new Date(2025, 11, 29),
    category: 'holiday',
    allDay: true,
    description: 'Winter Recess continues',
    descriptionES: 'Continúa el receso de invierno'
  },
  {
    id: 35,
    title: 'Winter Recess',
    titleES: 'Receso de Invierno',
    date: new Date(2025, 11, 30),
    category: 'holiday',
    allDay: true,
    description: 'Winter Recess continues',
    descriptionES: 'Continúa el receso de invierno'
  },
  {
    id: 36,
    title: 'Winter Recess',
    titleES: 'Receso de Invierno',
    date: new Date(2025, 11, 31),
    category: 'holiday',
    allDay: true,
    description: 'Winter Recess continues',
    descriptionES: 'Continúa el receso de invierno'
  },

  // January 2026
  {
    id: 37,
    title: 'Winter Recess',
    titleES: 'Receso de Invierno',
    date: new Date(2026, 0, 1),
    category: 'holiday',
    allDay: true,
    description: 'Winter Recess continues',
    descriptionES: 'Continúa el receso de invierno'
  },
  {
    id: 38,
    title: 'School Resumes',
    titleES: 'Se Reanudan las Clases',
    date: new Date(2026, 0, 2),
    category: 'academic',
    allDay: true,
    description: 'School resumes after winter recess',
    descriptionES: 'Se reanudan las clases después del receso de invierno'
  },
  {
    id: 39,
    title: 'Panther Pride Assembly',
    titleES: 'Asamblea Orgullo Pantera',
    date: new Date(2026, 0, 5),
    category: 'event',
    allDay: false,
    description: 'Monthly Panther Pride Assembly',
    descriptionES: 'Asamblea mensual de Orgullo Pantera'
  },
  {
    id: 40,
    title: 'Coffee and Community with Ms. Sanabria',
    titleES: 'Café y Comunidad con la Sra. Sanabria',
    date: new Date(2026, 0, 16),
    category: 'event',
    allDay: false,
    description: 'Coffee and Community session with Principal Sanabria',
    descriptionES: 'Sesión de café y comunidad con la directora Sanabria'
  },
  {
    id: 41,
    title: 'SLT Meeting 2:30-4:00 PM',
    titleES: 'Reunión SLT 2:30-4:00 PM',
    date: new Date(2026, 0, 16),
    category: 'meeting',
    allDay: false,
    description: 'School Leadership Team meeting',
    descriptionES: 'Reunión del equipo de liderazgo escolar'
  },
  {
    id: 42,
    title: 'MLK Day - School Not in Session',
    titleES: 'Día de MLK - Escuela No Está en Sesión',
    date: new Date(2026, 0, 19),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Martin Luther King Jr. Day',
    descriptionES: 'Escuela cerrada por el Día de Martin Luther King Jr.'
  },
  {
    id: 43,
    title: 'Reading Buddies',
    titleES: 'Compañeros de Lectura',
    date: new Date(2026, 0, 30),
    category: 'event',
    allDay: false,
    description: 'Reading Buddies program',
    descriptionES: 'Programa de compañeros de lectura'
  },

  // February 2026
  {
    id: 44,
    title: 'Panther Pride Assembly',
    titleES: 'Asamblea Orgullo Pantera',
    date: new Date(2026, 1, 2),
    category: 'event',
    allDay: false,
    description: 'Monthly Panther Pride Assembly',
    descriptionES: 'Asamblea mensual de Orgullo Pantera'
  },
  {
    id: 45,
    title: 'SLT Meeting 2:30-4:00 PM',
    titleES: 'Reunión SLT 2:30-4:00 PM',
    date: new Date(2026, 1, 13),
    category: 'meeting',
    allDay: false,
    description: 'School Leadership Team meeting',
    descriptionES: 'Reunión del equipo de liderazgo escolar'
  },
  {
    id: 46,
    title: 'Coffee and Community with Ms. Sanabria',
    titleES: 'Café y Comunidad con la Sra. Sanabria',
    date: new Date(2026, 1, 13),
    category: 'event',
    allDay: false,
    description: 'Coffee and Community session with Principal Sanabria',
    descriptionES: 'Sesión de café y comunidad con la directora Sanabria'
  },
  {
    id: 47,
    title: 'Midwinter Recess',
    titleES: 'Receso de Mitad de Invierno',
    date: new Date(2026, 1, 16),
    category: 'holiday',
    allDay: true,
    description: 'Midwinter Recess (February 16-20)',
    descriptionES: 'Receso de mitad de invierno (16-20 de febrero)'
  },
  {
    id: 48,
    title: 'Midwinter Recess',
    titleES: 'Receso de Mitad de Invierno',
    date: new Date(2026, 1, 17),
    category: 'holiday',
    allDay: true,
    description: 'Midwinter Recess continues',
    descriptionES: 'Continúa el receso de mitad de invierno'
  },
  {
    id: 49,
    title: 'Midwinter Recess',
    titleES: 'Receso de Mitad de Invierno',
    date: new Date(2026, 1, 18),
    category: 'holiday',
    allDay: true,
    description: 'Midwinter Recess continues',
    descriptionES: 'Continúa el receso de mitad de invierno'
  },
  {
    id: 50,
    title: 'Midwinter Recess',
    titleES: 'Receso de Mitad de Invierno',
    date: new Date(2026, 1, 19),
    category: 'holiday',
    allDay: true,
    description: 'Midwinter Recess continues',
    descriptionES: 'Continúa el receso de mitad de invierno'
  },
  {
    id: 51,
    title: 'Midwinter Recess',
    titleES: 'Receso de Mitad de Invierno',
    date: new Date(2026, 1, 20),
    category: 'holiday',
    allDay: true,
    description: 'Midwinter Recess continues',
    descriptionES: 'Continúa el receso de mitad de invierno'
  },
  {
    id: 52,
    title: 'Reading Buddies',
    titleES: 'Compañeros de Lectura',
    date: new Date(2026, 1, 27),
    category: 'event',
    allDay: false,
    description: 'Reading Buddies program',
    descriptionES: 'Programa de compañeros de lectura'
  },
  {
    id: 89,
    title: '5th Grade Senior Pictures',
    titleES: 'Fotos de Graduación de 5to Grado',
    date: new Date(2026, 1, 13),
    category: 'event',
    allDay: false,
    description: '5th grade senior pictures',
    descriptionES: 'Fotos de graduación de 5to grado'
  },
  {
    id: 90,
    title: 'PTA Bake Sale',
    titleES: 'Venta de Repostería PTA',
    date: new Date(2026, 1, 13),
    category: 'event',
    allDay: false,
    description: 'PTA Bake Sale during lunch periods',
    descriptionES: 'Venta de repostería de PTA durante los períodos de almuerzo'
  },
  {
    id: 91,
    title: 'PTA Meeting',
    titleES: 'Reunión PTA',
    date: new Date(2026, 1, 27),
    category: 'meeting',
    allDay: false,
    description: 'PTA meeting at 8:20 am in Parent Room',
    descriptionES: 'Reunión PTA a las 8:20 am en la Sala de Padres'
  },

  // March 2026
  {
    id: 53,
    title: 'Panther Pride Assembly',
    titleES: 'Asamblea Orgullo Pantera',
    date: new Date(2026, 2, 2),
    category: 'event',
    allDay: false,
    description: 'Monthly Panther Pride Assembly',
    descriptionES: 'Asamblea mensual de Orgullo Pantera'
  },
  {
    id: 54,
    title: 'Parent Teacher Conference - ½ Day',
    titleES: 'Conferencia de Padres y Maestros - Medio Día',
    date: new Date(2026, 2, 5),
    category: 'event',
    allDay: false,
    description: 'Parent Teacher Conference - Half Day',
    descriptionES: 'Conferencia de padres y maestros - Medio día'
  },
  {
    id: 55,
    title: 'SLT Meeting 2:30-4:00 PM',
    titleES: 'Reunión SLT 2:30-4:00 PM',
    date: new Date(2026, 2, 13),
    category: 'meeting',
    allDay: false,
    description: 'School Leadership Team meeting',
    descriptionES: 'Reunión del equipo de liderazgo escolar'
  },
  {
    id: 56,
    title: 'Classroom Showcase Grades 3rd-5th',
    titleES: 'Exhibición de Aula Grados 3ro-5to',
    date: new Date(2026, 2, 16),
    category: 'event',
    allDay: false,
    description: 'Classroom Showcase for grades 3rd through 5th',
    descriptionES: 'Exhibición de aula para grados 3ro a 5to'
  },
  {
    id: 57,
    title: 'Classroom Showcase Grades 3K-2nd',
    titleES: 'Exhibición de Aula Grados 3K-2do',
    date: new Date(2026, 2, 17),
    category: 'event',
    allDay: false,
    description: 'Classroom Showcase for grades 3K through 2nd',
    descriptionES: 'Exhibición de aula para grados 3K a 2do'
  },
  {
    id: 58,
    title: 'Eid al-Fitr - School Not in Session',
    titleES: 'Eid al-Fitr - Escuela No Está en Sesión',
    date: new Date(2026, 2, 20),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Eid al-Fitr',
    descriptionES: 'Escuela cerrada por Eid al-Fitr'
  },
  {
    id: 59,
    title: 'Coffee and Community with Ms. Sanabria',
    titleES: 'Café y Comunidad con la Sra. Sanabria',
    date: new Date(2026, 2, 27),
    category: 'event',
    allDay: false,
    description: 'Coffee and Community session with Principal Sanabria',
    descriptionES: 'Sesión de café y comunidad con la directora Sanabria'
  },
  {
    id: 60,
    title: 'Reading Buddies',
    titleES: 'Compañeros de Lectura',
    date: new Date(2026, 2, 27),
    category: 'event',
    allDay: false,
    description: 'Reading Buddies program',
    descriptionES: 'Programa de compañeros de lectura'
  },
  {
    id: 92,
    title: 'Family Basketball Event',
    titleES: 'Evento de Baloncesto Familiar',
    date: new Date(2026, 2, 6),
    category: 'event',
    allDay: false,
    description: 'Family Basketball event at 2:30 pm',
    descriptionES: 'Evento de baloncesto familiar a las 2:30 pm'
  },
  {
    id: 93,
    title: 'Healthy Routines Family Workshop',
    titleES: 'Taller Familiar de Rutinas Saludables',
    date: new Date(2026, 2, 11),
    category: 'event',
    allDay: false,
    description: 'Healthy Routines family workshop at 8:30 am and 2:30 pm in Parent Room',
    descriptionES: 'Taller familiar de rutinas saludables a las 8:30 am y 2:30 pm en la Sala de Padres'
  },
  {
    id: 94,
    title: 'PTA Meeting',
    titleES: 'Reunión PTA',
    date: new Date(2026, 2, 17),
    category: 'meeting',
    allDay: false,
    description: 'PTA meeting at 8:20 am in Parent Room',
    descriptionES: 'Reunión PTA a las 8:20 am en la Sala de Padres'
  },
  {
    id: 95,
    title: 'Multicultural Family Event',
    titleES: 'Evento Familiar Multicultural',
    date: new Date(2026, 2, 19),
    category: 'event',
    allDay: false,
    description: 'Multicultural Family event at 2:30 pm',
    descriptionES: 'Evento familiar multicultural a las 2:30 pm'
  },

  // April 2026
  {
    id: 61,
    title: 'Spring Recess - School Not in Session',
    titleES: 'Receso de Primavera - Escuela No Está en Sesión',
    date: new Date(2026, 3, 2),
    category: 'holiday',
    allDay: true,
    description: 'Spring Recess begins (April 2-10)',
    descriptionES: 'Comienza el receso de primavera (2-10 de abril)'
  },
  {
    id: 62,
    title: 'Spring Recess - School Not in Session',
    titleES: 'Receso de Primavera - Escuela No Está en Sesión',
    date: new Date(2026, 3, 3),
    category: 'holiday',
    allDay: true,
    description: 'Spring Recess continues',
    descriptionES: 'Continúa el receso de primavera'
  },
  {
    id: 63,
    title: 'Spring Recess - School Not in Session',
    titleES: 'Receso de Primavera - Escuela No Está en Sesión',
    date: new Date(2026, 3, 4),
    category: 'holiday',
    allDay: true,
    description: 'Spring Recess continues',
    descriptionES: 'Continúa el receso de primavera'
  },
  {
    id: 64,
    title: 'Spring Recess - School Not in Session',
    titleES: 'Receso de Primavera - Escuela No Está en Sesión',
    date: new Date(2026, 3, 5),
    category: 'holiday',
    allDay: true,
    description: 'Spring Recess continues',
    descriptionES: 'Continúa el receso de primavera'
  },
  {
    id: 65,
    title: 'Spring Recess - School Not in Session',
    titleES: 'Receso de Primavera - Escuela No Está en Sesión',
    date: new Date(2026, 3, 6),
    category: 'holiday',
    allDay: true,
    description: 'Spring Recess continues',
    descriptionES: 'Continúa el receso de primavera'
  },
  {
    id: 66,
    title: 'Spring Recess - School Not in Session',
    titleES: 'Receso de Primavera - Escuela No Está en Sesión',
    date: new Date(2026, 3, 7),
    category: 'holiday',
    allDay: true,
    description: 'Spring Recess continues',
    descriptionES: 'Continúa el receso de primavera'
  },
  {
    id: 67,
    title: 'Spring Recess - School Not in Session',
    titleES: 'Receso de Primavera - Escuela No Está en Sesión',
    date: new Date(2026, 3, 8),
    category: 'holiday',
    allDay: true,
    description: 'Spring Recess continues',
    descriptionES: 'Continúa el receso de primavera'
  },
  {
    id: 68,
    title: 'Spring Recess - School Not in Session',
    titleES: 'Receso de Primavera - Escuela No Está en Sesión',
    date: new Date(2026, 3, 9),
    category: 'holiday',
    allDay: true,
    description: 'Spring Recess continues',
    descriptionES: 'Continúa el receso de primavera'
  },
  {
    id: 69,
    title: 'Spring Recess - School Not in Session',
    titleES: 'Receso de Primavera - Escuela No Está en Sesión',
    date: new Date(2026, 3, 10),
    category: 'holiday',
    allDay: true,
    description: 'Spring Recess ends',
    descriptionES: 'Termina el receso de primavera'
  },
  {
    id: 70,
    title: 'Coffee and Community with Ms. Sanabria',
    titleES: 'Café y Comunidad con la Sra. Sanabria',
    date: new Date(2026, 3, 17),
    category: 'event',
    allDay: false,
    description: 'Coffee and Community session with Principal Sanabria',
    descriptionES: 'Sesión de café y comunidad con la directora Sanabria'
  },
  {
    id: 71,
    title: 'SLT Meeting 2:30-4:00 PM',
    titleES: 'Reunión SLT 2:30-4:00 PM',
    date: new Date(2026, 3, 17),
    category: 'meeting',
    allDay: false,
    description: 'School Leadership Team meeting',
    descriptionES: 'Reunión del equipo de liderazgo escolar'
  },
  {
    id: 96,
    title: 'Family Egg Hunt',
    titleES: 'Búsqueda de Huevos Familiar',
    date: new Date(2026, 3, 1),
    category: 'event',
    allDay: false,
    description: 'Family Egg Hunt: 2:30-3:30 pm Pre-K to 2nd grade, 3:45-4:45 pm Grades 3rd-5th',
    descriptionES: 'Búsqueda de huevos familiar: 2:30-3:30 pm Pre-K a 2do grado, 3:45-4:45 pm Grados 3ro-5to'
  },
  {
    id: 97,
    title: 'PTA Meeting',
    titleES: 'Reunión PTA',
    date: new Date(2026, 3, 17),
    category: 'meeting',
    allDay: false,
    description: 'PTA meeting at 8:20 am in Parent Room',
    descriptionES: 'Reunión PTA a las 8:20 am en la Sala de Padres'
  },

  // May 2026
  {
    id: 72,
    title: 'Panther Pride Assembly',
    titleES: 'Asamblea Orgullo Pantera',
    date: new Date(2026, 4, 4),
    category: 'event',
    allDay: false,
    description: 'Monthly Panther Pride Assembly',
    descriptionES: 'Asamblea mensual de Orgullo Pantera'
  },
  {
    id: 73,
    title: 'Parent Teacher Conference Evening',
    titleES: 'Conferencia de Padres y Maestros en la Tarde',
    date: new Date(2026, 4, 7),
    category: 'event',
    allDay: false,
    description: 'Parent Teacher Conference Evening session',
    descriptionES: 'Sesión vespertina de conferencia de padres y maestros'
  },
  {
    id: 74,
    title: 'Coffee and Community with Ms. Sanabria',
    titleES: 'Café y Comunidad con la Sra. Sanabria',
    date: new Date(2026, 4, 15),
    category: 'event',
    allDay: false,
    description: 'Coffee and Community session with Principal Sanabria',
    descriptionES: 'Sesión de café y comunidad con la directora Sanabria'
  },
  {
    id: 75,
    title: 'Classroom Showcase Grades 3rd-5th',
    titleES: 'Exhibición de Aula Grados 3ro-5to',
    date: new Date(2026, 4, 18),
    category: 'event',
    allDay: false,
    description: 'Classroom Showcase for grades 3rd through 5th',
    descriptionES: 'Exhibición de aula para grados 3ro a 5to'
  },
  {
    id: 76,
    title: 'Classroom Showcase Grades 3K-2nd',
    titleES: 'Exhibición de Aula Grados 3K-2do',
    date: new Date(2026, 4, 19),
    category: 'event',
    allDay: false,
    description: 'Classroom Showcase for grades 3K through 2nd',
    descriptionES: 'Exhibición de aula para grados 3K a 2do'
  },
  {
    id: 77,
    title: 'SLT Meeting 2:30-4:00 PM',
    titleES: 'Reunión SLT 2:30-4:00 PM',
    date: new Date(2026, 4, 20),
    category: 'meeting',
    allDay: false,
    description: 'School Leadership Team meeting',
    descriptionES: 'Reunión del equipo de liderazgo escolar'
  },
  {
    id: 78,
    title: 'Memorial Day - School Not in Session',
    titleES: 'Día de los Caídos - Escuela No Está en Sesión',
    date: new Date(2026, 4, 25),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Memorial Day',
    descriptionES: 'Escuela cerrada por el Día de los Caídos'
  },
  {
    id: 79,
    title: 'Eid al-Adha - School Not in Session',
    titleES: 'Eid al-Adha - Escuela No Está en Sesión',
    date: new Date(2026, 4, 27),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Eid al-Adha',
    descriptionES: 'Escuela cerrada por Eid al-Adha'
  },
  {
    id: 80,
    title: 'Reading Buddies',
    titleES: 'Compañeros de Lectura',
    date: new Date(2026, 4, 29),
    category: 'event',
    allDay: false,
    description: 'Reading Buddies program',
    descriptionES: 'Programa de compañeros de lectura'
  },
  {
    id: 98,
    title: 'PTA Muffins with Mom and Mother Figure',
    titleES: 'Muffins con Mamá y Figura Materna de PTA',
    date: new Date(2026, 4, 6),
    category: 'event',
    allDay: false,
    description: 'PTA muffins with mom and mother figure at 8:30 am in Parent Room',
    descriptionES: 'Muffins con mamá y figura materna de PTA a las 8:30 am en la Sala de Padres'
  },
  {
    id: 99,
    title: 'PS 155 Community School Forum',
    titleES: 'Foro Escolar Comunitario PS 155',
    date: new Date(2026, 4, 15),
    category: 'event',
    allDay: false,
    description: 'PS 155 Community school forum at 2:30 pm',
    descriptionES: 'Foro escolar comunitario PS 155 a las 2:30 pm'
  },

  // June 2026
  {
    id: 81,
    title: 'Chancellor\'s Day - Students Do Not Attend',
    titleES: 'Día del Canciller - Los Estudiantes No Asisten',
    date: new Date(2026, 5, 4),
    category: 'holiday',
    allDay: true,
    description: 'Chancellor\'s Day - Students do not attend',
    descriptionES: 'Día del Canciller - Los estudiantes no asisten'
  },
  {
    id: 82,
    title: 'Clerical Day - Students Do Not Attend',
    titleES: 'Día Administrativo - Los Estudiantes No Asisten',
    date: new Date(2026, 5, 5),
    category: 'holiday',
    allDay: true,
    description: 'Clerical Day - Students do not attend',
    descriptionES: 'Día administrativo - Los estudiantes no asisten'
  },
  {
    id: 83,
    title: 'SLT Meeting 2:30-4:00 PM',
    titleES: 'Reunión SLT 2:30-4:00 PM',
    date: new Date(2026, 5, 10),
    category: 'meeting',
    allDay: false,
    description: 'School Leadership Team meeting',
    descriptionES: 'Reunión del equipo de liderazgo escolar'
  },
  {
    id: 84,
    title: 'Field Day',
    titleES: 'Día de Campo',
    date: new Date(2026, 5, 12),
    category: 'event',
    allDay: false,
    description: 'Field Day',
    descriptionES: 'Día de campo'
  },
  {
    id: 85,
    title: '5th Grade Dance',
    titleES: 'Baile de 5to Grado',
    date: new Date(2026, 5, 17),
    category: 'event',
    allDay: false,
    description: '5th Grade Dance event',
    descriptionES: 'Evento de baile de 5to grado'
  },
  {
    id: 100,
    title: 'Donuts with Dad and Father Figure',
    titleES: 'Donas con Papá y Figura Paterna',
    date: new Date(2026, 5, 16),
    category: 'event',
    allDay: false,
    description: 'Donuts with dad and father figure at 8:30 am',
    descriptionES: 'Donas con papá y figura paterna a las 8:30 am'
  },
  {
    id: 86,
    title: '3K/Pre-K Moving Up Ceremony',
    titleES: 'Ceremonia de Graduación 3K/Pre-K',
    date: new Date(2026, 5, 18),
    category: 'event',
    allDay: false,
    description: '3K/Pre-K Moving Up Ceremony',
    descriptionES: 'Ceremonia de graduación 3K/Pre-K'
  },
  {
    id: 87,
    title: 'Juneteenth - School Not in Session',
    titleES: 'Juneteenth - Escuela No Está en Sesión',
    date: new Date(2026, 5, 19),
    category: 'holiday',
    allDay: true,
    description: 'School closed for Juneteenth',
    descriptionES: 'Escuela cerrada por Juneteenth'
  },
  {
    id: 88,
    title: 'Kindergarten Moving Up Ceremony',
    titleES: 'Ceremonia de Graduación de Kindergarten',
    date: new Date(2026, 5, 23),
    category: 'event',
    allDay: false,
    description: 'Kindergarten Moving Up Ceremony',
    descriptionES: 'Ceremonia de graduación de Kindergarten'
  }
];

export default events;
